import React from 'react'
import classNames from 'classnames'
import injectStyles from 'react-jss'
import { styles } from './styles'
import { GERMANY_CONTRACT_STATUSES } from '../../../../../../../../shared/constants'

const StatusLabel = ({ data, classes, isAddendum }) => {
  const generateStatus = () => {
    if (!data.signedAt && !isAddendum) {
      return 'PENDING'
    } else {
      return data.status
    }
  }
  const status = generateStatus()
  const titleMap = {
    [GERMANY_CONTRACT_STATUSES.STATUS_ACTIVE]: 'Active',
    [GERMANY_CONTRACT_STATUSES.STATUS_EXPIRING_SOON]: 'Renewal Pending',
    'PENDING': 'Pending signing',
    [GERMANY_CONTRACT_STATUSES.STATUS_TERMINATED]: 'Terminated',
    [GERMANY_CONTRACT_STATUSES.STATUS_SIGNED]: 'Signed',
  }
  return (
    <div
      className={classNames({
        [classes.wrapper]: true,
        [classes.activeWrapper]:
          status == [GERMANY_CONTRACT_STATUSES.STATUS_ACTIVE],
        [classes.activeWrapper]: [GERMANY_CONTRACT_STATUSES.STATUS_SIGNED],
        [classes.expiredWrapper]:
          status == [GERMANY_CONTRACT_STATUSES.STATUS_TERMINATED],
        [classes.pendingWrapper]: status == 'PENDING',
        [classes.concludedWrapper]:
          status == [GERMANY_CONTRACT_STATUSES.STATUS_EXPIRING_SOON],
      })}
    >
      {titleMap[status]}
    </div>
  )
}

export default injectStyles(styles)(StatusLabel)
